import { render, staticRenderFns } from "./CRUDTable.vue?vue&type=template&id=b48fcf02"
import script from "./CRUDTable.vue?vue&type=script&lang=js"
export * from "./CRUDTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports